export const DIALOG_BOX_TYPE = {
  DISMISSIBLE_DIALOG: 0,
  ACCEPT_CANCEL_DIALOG: 1,
};
